import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextInventory } from '../Inventory';
import { AppService } from '../../../../models/app.service.model';
import { Company } from '../../../../models/company.model';
import { Settings } from '../../../../models/settings.model';
import { Category } from '../../../../models/category.model';
import { AccountingAccount } from '../../../../models/accounting.account.model';
import { Brand } from '../../../../models/brands.inventory.model';

export interface ProductPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  categoriesForCompany: Category[] | null,
  accountingExpenseAccountsForCompany: AccountingAccount[] | null,
  accountingVatAccountsForCompany: AccountingAccount[] | null,
  accountingIncomeAccountsForCompany: AccountingAccount[] | null,
  brandsForCompany: Brand[],
  setCategoriesForCompany: Dispatch<SetStateAction<Category[] | null>>,
  setBrandsForCompany: Dispatch<SetStateAction<Brand[]>>,
  loadSettingsForCompany: Function,
  loadProductsForCompany: Function,
  loadBrandsForCompany: Function
};

const ProductPage: React.FunctionComponent<ProductPageProps> = props => {
  const {setRoute, appServiceForUser, companyForUser, settingsForCompany, categoriesForCompany, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingIncomeAccountsForCompany, brandsForCompany, setCategoriesForCompany, setBrandsForCompany, loadSettingsForCompany, loadProductsForCompany, loadBrandsForCompany} = UseOutletContextInventory()

  return (
    <Outlet context={{setRoute, appServiceForUser, companyForUser, settingsForCompany, categoriesForCompany, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingIncomeAccountsForCompany, brandsForCompany, setCategoriesForCompany, setBrandsForCompany, loadSettingsForCompany, loadProductsForCompany, loadBrandsForCompany}}></Outlet>
  );
}

export function UseOutletContextProduct() {
  return useOutletContext<ContexType>()
};

export default ProductPage;
